import React, { createContext, useContext, useState, useEffect } from 'react';
import { apiGet } from '../utils/apiClient';
import { DEFAULT_TIMEZONE, setGlobalTimezone } from '../utils/timezoneUtils';

const TimezoneContext = createContext(null);

export const useTimezone = () => {
  const context = useContext(TimezoneContext);
  if (!context) {
    return { timezone: DEFAULT_TIMEZONE };
  }
  return context;
};

export const TimezoneProvider = ({ children }) => {
  const [timezone, setTimezone] = useState(DEFAULT_TIMEZONE);

  useEffect(() => {
    const fetchTimezone = async () => {
      try {
        const response = await apiGet('/api/settings');
        if (response.ok) {
          const data = await response.json();
          if (data.timezone) {
            setTimezone(data.timezone);
            setGlobalTimezone(data.timezone);
          }
        }
      } catch {
        // Keep default timezone on error
      }
    };
    fetchTimezone();
  }, []);

  // Keep global in sync if timezone changes via setTimezone
  useEffect(() => {
    setGlobalTimezone(timezone);
  }, [timezone]);

  return (
    <TimezoneContext.Provider value={{ timezone, setTimezone }}>
      {children}
    </TimezoneContext.Provider>
  );
};
